import React from 'react'
import {Swiper,SwiperSlide} from 'swiper/react'
import {Pagination,Navigation} from "swiper"

import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
 import "./Slider.css"

import {SliderProducts} from "../../data/products" 
const Slider = () => {
  return (
<div className="s_container">
    <Swiper
    modules={[Pagination,Navigation]}
    navigation={true}
    className="myswiper"
    loopFillGroupWithBlank={true}
     spaceBetween={40}
     slidesPerView={3}
     slidesPerGroup={1}
     loop={true}
     breakpoints={{
    640:{slidesPerView:2},
0:{slidesPerView:1}
}}
     >

        {SliderProducts.map((slide,i)=>(
            <SwiperSlide key={i}>
<div className="left-s">
    <div className="name">
        <span>{slide.name}</span>
        <span>{slide.detail}</span>
    </div>
    <span>{slide.price}$</span>
    <div>Shop NOW</div>
</div>
<img src={slide.img}   className="img-s"  />
</SwiperSlide>
        ))}

 
    </Swiper>
</div>
    )
}

export default Slider